
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M32.077 5.5C31.482 5.5 31 6.009 31 6.636v22.728c0 .627.482 1.136 1.077 1.136h11.846c.595 0 1.077-.509 1.077-1.136V6.636c0-.627-.482-1.136-1.077-1.136zM20.5 36.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11","fill":"#D0EFEC"}}),_c('g',{staticClass:"i-desktop",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Rectangle 23",attrs:{"d":"M29.717 7.5H2v37h40V30.95"}}),_c('path',{staticClass:"i-Line 24",attrs:{"d":"M1.967 12h27.654"}})]),_c('g',{staticClass:"i-phone",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Vector 129",attrs:{"stroke-linecap":"round","d":"M46 27.912V4.5a1 1 0 0 0-1-1H33.588a1 1 0 0 0-1 1v23.412a1 1 0 0 0 1 1H45a1 1 0 0 0 1-1Z"}}),_c('path',{staticClass:"i-Vector 132",attrs:{"stroke-linecap":"square","d":"M38.235 5.618h2.118"}})]),_c('g',{staticClass:"i-combo-lock",attrs:{"stroke":"#234652"}},[_c('circle',{staticClass:"i-Ellipse 10",attrs:{"cx":"22","cy":"31.5","r":"5.5"}}),_c('path',{staticClass:"i-Rectangle 18",attrs:{"d":"M19 26.5v-3a3 3 0 1 1 6 0v3"}}),_c('circle',{staticClass:"i-Ellipse 11",attrs:{"cx":"22","cy":"31.5","r":"1.5"}})]),_c('g',{staticClass:"i-key",attrs:{"stroke":"#234652"}},[_c('circle',{staticClass:"i-Ellipse 593",attrs:{"r":"2","transform":"matrix(-1 0 0 1 39.5 21)"}}),_c('path',{staticClass:"i-Line 118",attrs:{"d":"M39.5 19V9.5"}}),_c('path',{staticClass:"i-Line 120",attrs:{"stroke-width":".8","d":"M40 12.756h2"}}),_c('path',{staticClass:"i-Line 121",attrs:{"stroke-width":".8","d":"M40 10.938h1.5"}})])])
          )
        }
      }
    